import globalAxios, { AxiosInstance } from "axios";
import {
  CodeApi,
  Configuration,
  AccountingAppApi,
  ConfigTrustApi,
  InvestigationApi,
  CalendarApi,
  PracticeApi,
  TimeEntryApi,
  TrustTeamMemberApi,
  NotesApi,
  AccountApi,
  CorrespondenceApi,
  PeopleApi,
  RoutineApi,
  FollowUpApi,
  InvestigatorWorkingPaperApi,
  LawIdApi,
  ComplianceFormApi,
  PracticeAtcsApi,
  ExternalExaminerApi,
  FileAtcsApi,
  PageAtcsApi,
  PartAFormApi,
  DateApi,
  PeopleAtcsApi,
  PartBFormApi,
  EeReportApi,
} from "@/shared/modules/typescript-trustapi-client";

export const BASE_PATH = "/".replace(/\/+$/, "");

export class TrustAPI {
  public CalendarApi?: CalendarApi;
  public CodeApi?: CodeApi;
  public AccountingAppApi?: AccountingAppApi;
  public ConfigTrustApi?: ConfigTrustApi;
  public InvestigationApi?: InvestigationApi;
  public PracticeApi?: PracticeApi;
  public TimeEntryApi?: TimeEntryApi;
  public TrustTeamMemberApi?: TrustTeamMemberApi;
  public NotesApi?: NotesApi;
  public AccountApi?: AccountApi;
  public CorrespondenceApi?: CorrespondenceApi;
  public PeopleApi?: PeopleApi;
  public RoutineApi?: RoutineApi;
  public FollowUpApi?: FollowUpApi;
  public InvestigatorWorkingPaperApi?: InvestigatorWorkingPaperApi;
  public LawIdApi?: LawIdApi;
  public ComplianceFormApi?: ComplianceFormApi;
  public PracticeAtcsApi?: PracticeAtcsApi;
  public ExternalExaminerApi?: ExternalExaminerApi;
  public FileAtcsApi?: FileAtcsApi;
  public PageAtcsApi?: PageAtcsApi;
  public PartAFormApi?: PartAFormApi;
  public PartBFormApi?: PartBFormApi;
  public DateApi?: any;
  public PeopleAtcsApi?: PeopleAtcsApi;
  public EeReportApi?: EeReportApi;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected axios: AxiosInstance = globalAxios
  ) {
    this.CodeApi = new CodeApi(configuration, basePath, axios);
    this.AccountingAppApi = new AccountingAppApi(configuration, basePath, axios);
    this.ConfigTrustApi = new ConfigTrustApi(configuration, basePath, axios);
    this.InvestigationApi = new InvestigationApi(configuration, basePath, axios);
    this.PracticeApi = new PracticeApi(configuration, basePath, axios);
    this.CalendarApi = new CalendarApi(configuration, basePath, axios);
    this.TimeEntryApi = new TimeEntryApi(configuration, basePath, axios);
    this.TrustTeamMemberApi = new TrustTeamMemberApi(configuration, basePath, axios);
    this.NotesApi = new NotesApi(configuration, basePath, axios);
    this.AccountApi = new AccountApi(configuration, basePath, axios);
    this.CorrespondenceApi = new CorrespondenceApi(configuration, basePath, axios);
    this.PeopleApi = new PeopleApi(configuration, basePath, axios);
    this.RoutineApi = new RoutineApi(configuration, basePath, axios);
    this.FollowUpApi = new FollowUpApi(configuration, basePath, axios);
    this.InvestigatorWorkingPaperApi = new InvestigatorWorkingPaperApi(configuration, basePath, axios);
    this.LawIdApi = new LawIdApi(configuration, basePath, axios);
    this.ComplianceFormApi = new ComplianceFormApi(configuration, basePath, axios);
    this.PracticeAtcsApi = new PracticeAtcsApi(configuration, basePath, axios);
    this.ExternalExaminerApi = new ExternalExaminerApi(configuration, basePath, axios);
    this.FileAtcsApi = new FileAtcsApi(configuration, basePath, axios);
    this.PageAtcsApi = new PageAtcsApi(configuration, basePath, axios);
    this.PartAFormApi = new PartAFormApi(configuration, basePath, axios);
    this.PartBFormApi = new PartBFormApi(configuration, basePath, axios);
    this.DateApi = new DateApi(configuration, basePath, axios);
    this.PeopleAtcsApi = new PeopleAtcsApi(configuration, basePath, axios);
    this.EeReportApi = new EeReportApi(configuration, basePath, axios);
  }
}
